import { useEffect } from "react";
import { setWidgetLanguage } from "@/core";

const useHostLanguageSync = (
  preferredLang?: string,
  onChangeLang?: (lang: string) => void,
  enablePostMessage: boolean = true,
) => {
  useEffect(() => {
    const detectedLang = (
      preferredLang ||
      localStorage.getItem("i18nLang") ||
      document.documentElement.lang ||
      navigator.language ||
      "el"
    )
      .substring(0, 2)
      .toLowerCase();

    const apply = (lang: string) => {
      const normalized = setWidgetLanguage(lang);
      onChangeLang?.(normalized);
    };

    apply(detectedLang);

    const observer = new MutationObserver(() => {
      const htmlLang = document.documentElement.lang?.substring(0, 2);
      if (htmlLang) apply(htmlLang);
    });

    observer.observe(document.documentElement, { attributes: true });

    const handleMessage = (event: MessageEvent) => {
      if (
        enablePostMessage &&
        event.data?.type === "LANG_CHANGE" &&
        typeof event.data.lang === "string"
      ) {
        apply(event.data.lang);
      }
    };

    if (enablePostMessage) {
      window.addEventListener("message", handleMessage);
    }

    return () => {
      observer.disconnect();
      if (enablePostMessage) {
        window.removeEventListener("message", handleMessage);
      }
    };
  }, [preferredLang, onChangeLang, enablePostMessage]);
};

export default useHostLanguageSync;
